import styled from "styled-components";
import { FC } from "react";
import { Cross } from "../../icons";

export const TagContainer = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  background: #2cd19e;
  color: white;
  font-size: 12px;
  line-height: 1;
  border-radius: 5px;
  padding: 6px 8px 6px 10px;
  max-width: 100%;
  word-break: break-word;
`;

const StyledCross = styled(Cross)<{ disabled?: boolean }>`
  cursor: pointer;
  path {
    stroke: ${({ disabled }) => (disabled ? "#eee" : "#fff")};
  }
`;

interface TagEntryProps {
  tag: string;
  onRemoveTag: () => any;
  disabled: boolean;
}

export const TagEntry: FC<TagEntryProps> = ({ tag, onRemoveTag, disabled }) => {
  return (
    <TagContainer>
      <span>{tag}</span>{" "}
      <StyledCross
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            onRemoveTag();
          }
        }}
      />
    </TagContainer>
  );
};
